import { defineStore } from 'pinia'

export const useBlitzStore = defineStore('BlitzStore', {
  persist: true,
  state: () => {
    return {
      user: null,
      token: null
    }
  },
  actions: {
    login (user, token) {
      this.user = user
      this.token = token
      if (user?.tenant) {
        window.tenant = { name: user.tenant.name, uuid: user.tenant.uuid }
      }
    },
    logout () {
      this.user = null
      this.token = null
    }
  }
})
